import { useCallback, useMemo } from "react";
import { FormInstance } from "antd";
import dayjs from "../../../../configs/dayjs";
import { useExportTxt } from "../../../../lib/hooks/useExportTxt";

export const useExport = (
  form: FormInstance,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  onChangeIsOpen: (value: boolean) => void
) => {
  const DATE_FORMAT = "MM-DD-YYYY";

  const onSuccess = useCallback(() => {
    setIsLoading(false);

    onChangeIsOpen(false);
  }, [onChangeIsOpen, setIsLoading]);

  const fileName = useMemo(() => `ACH ${dayjs().format(DATE_FORMAT)} PTMS`, []);

  const { onExport } = useExportTxt("ACH", fileName, onSuccess);

  const onExportClicked = useCallback(async () => {
    try {
      const values = await form.validateFields();

      const request: any = {
        batchDate: dayjs(values.batchDate).format(),
        effectiveDate: dayjs(values.effectiveDate).format(),
        descriptiveDate: values.descriptiveDate,
      };

      setIsLoading(true);

      await onExport(request);
    } catch {
      setIsLoading(false);
    }
  }, [form, setIsLoading, onExport]);

  return { onExportClicked };
};
